const defaultState = {
  actors: [],
  loading: true,
  readOnly: false
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {
    case "FETCH_SHOOTING_DAY_CREW_PENDING": {
      return {
        ...state,
        loading: true,
        errors: null
      };
    }

    case "FETCH_SHOOTING_DAY_CREW_FULFILLED": {
      return {
        ...state,
        crew: action.payload.data.crewDepartments,
        readOnly: action.payload.data.readOnly,
        loading: false,
        errors: null
      };
    }

    case "UPDATE_SHOOTING_DAY_CREW_PENDING": {
      return {
        ...state,
        errors: null
      };
    }

    case "UPDATE_SHOOTING_DAY_CREW_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loading: false
      };
    }

    case "UPDATE_SHOOTING_DAY_CREW_FULFILLED": {
      return {
        ...state,
        crew: action.meta.crew.crewDepartments,
        errors: null,
        loading: false,
        saved: true
      };
    }

    case "RESET_SHOOTING_DAY_CREW": {
      return {
        ...state,
        saved: false
      };
    }

    default:
      return state;
  }
};

export default reducer;
